import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { router } from "./router";
import { setUnauthorizedHandler } from "./api/client";
import { queryKeys } from "./lib/query-keys";
import { ErrorBoundary } from "./components/layout/ErrorBoundary";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,
            refetchOnWindowFocus: true,
            retry: 1,
        },
        mutations: { retry: false },
    },
});

export default function App() {

    useEffect(() => {

        setUnauthorizedHandler(() => {

            queryClient.removeQueries({ queryKey: queryKeys.auth.me() });
            // imperative navigation to /login. router.navigate is exposed by
            // createBrowserRouter and is the cleanest way to redirect from
            // outside the React tree.
            router.navigate("/login", { replace: true });
        });

        return () => setUnauthorizedHandler(null);
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <ErrorBoundary>
                <RouterProvider router={router} />
            </ErrorBoundary>
            <Toaster richColors closeButton />
        </QueryClientProvider>
    );
}
